import { Button, Col, Container, Row } from "react-bootstrap";
import vamosjuntos from "../../assets/img/logo-white.png";
import web from "../../assets/img/web.png";
import yt from "../../assets/img/yt.png";
import fb from "../../assets/img/fb.svg";
import ig from "../../assets/img/ig.png";
import { Link } from "react-scroll";

const Footer = () => {
  const query = new URLSearchParams(window.location.search);
  if (query) {
    if (query.get("utm_source")) {
      sessionStorage.setItem("utm_source", query.get("utm_source"));
    }
    if (query.get("utm_medium")) {
      sessionStorage.setItem("utm_medium", query.get("utm_medium"));
    }
  }
  const utm_source = query && query.get("utm_source");
  const utm_medium = query && query.get("utm_medium");

  let utms = "";
  if (utm_source !== null && utm_medium !== null) {
    utms = `?utm_source=${utm_source}&utm_medium=${utm_medium}`;
  }

  return (
    <>
      <Container fluid className="footer pb-4" name="footer">
        <Row>
          <Col>
            <Container>
              <Row>
                <Col md={12} xs={12} className="mx-auto p-0 m-0">
                  <Row className="d-flex justify-content-between flex-md-row flex-column">
                    <Col
                      className="d-flex justify-content-md-between justify-content-center flex-md-row flex-column mx-auto"
                      md={3}
                      xs={11}
                    >
                      <div className="text-md-start text-center">
                        <img src={vamosjuntos} className="img-fluid" alt="Montironi" />
                      </div>
                    </Col>

                    <Col md={2} xs={12} className="pe-0 me-0 text-md-start text-center pt-md-0 pb-md-0 pt-3 pb-3">
                      <p className="text-footer">Vení a conocerla a una de nuestras sucursales.</p>
                    </Col>

                    <Col
                      md={3}
                      xs={12}
                      className="text-center d-flex justify-content-md-end justify-content-center  flex-md-row flex-column pe-0 me-0 pb-md-0  pb-3"
                    >
                      <div className="mx-auto">
                        <a
                          className="btn-blue-destacado ps-5 pe-5 pb-2 pt-2"
                          to="registrate"
                          href={"#form"}
                          target={"_self"}
                          rel="noreferrer"
                          style={{ textDecoration: "none", cursor: "pointer", color: "#fff" }}
                        >
                          Consultar
                        </a>
                      </div>
                    </Col>

                    <Col
                      md={3}
                      xs={12}
                      className="d-flex justify-content-md-end justify-content-center  flex-md-row flex-column ms-0 ps-0 align-items-center align-content-center pt-md-0 pb-md-0 pt-3 pb-3"
                    >
                      <p className="text-footer text-md-start text-center">
                        Seguínos y enterate de
                        <br /> todas nuestras novedades
                      </p>
                      <div className="d-flex justify-content-md-start justify-content-center align-items-center align-content-center ps-4">
                        <div className="" style={{ borderRight: "1px solid #fff", minWidth: "30px" }}>
                          <a href="https://www.facebook.com/MontironiFord" target="_blank" rel="noreferrer">
                          <svg width="16" height="27" viewBox="0 0 16 27" fill="none" xmlns="http://www.w3.org/2000/svg" className="imagenConFiltro">
                            <path d="M15 1H11.1818C9.49408 1 7.87546 1.65848 6.68205 2.83058C5.48863 4.00269 4.81818 5.5924 4.81818 7.25V11H1V16H4.81818V26H9.90909V16H13.7273L15 11H9.90909V7.25C9.90909 6.91848 10.0432 6.60054 10.2819 6.36612C10.5205 6.1317 10.8443 6 11.1818 6H15V1Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          </a>
                        </div>
                        <div className=" text-end" style={{ minWidth: "40px" }} target="_blank">
                          <a href="https://www.instagram.com/montironi.ford/">
                          <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" className="imagenConFiltro">
<g clip-path="url(#clip0_263_134)">
<path d="M21.9584 2.5H9.04171C5.47487 2.5 2.58337 5.29822 2.58337 8.75V21.25C2.58337 24.7018 5.47487 27.5 9.04171 27.5H21.9584C25.5252 27.5 28.4167 24.7018 28.4167 21.25V8.75C28.4167 5.29822 25.5252 2.5 21.9584 2.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M20.6666 14.2124C20.826 15.2527 20.6424 16.3152 20.1419 17.2487C19.6414 18.1822 18.8494 18.9392 17.8787 19.412C16.908 19.8848 15.8079 20.0494 14.735 19.8823C13.6621 19.7152 12.6709 19.225 11.9024 18.4813C11.134 17.7377 10.6274 16.7785 10.4548 15.7402C10.2821 14.7018 10.4522 13.6373 10.9408 12.6979C11.4294 11.7585 12.2116 10.9921 13.1762 10.5077C14.1408 10.0233 15.2387 9.84562 16.3137 9.99989C17.4102 10.1572 18.4254 10.6517 19.2092 11.4103C19.9931 12.1688 20.504 13.1512 20.6666 14.2124Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_263_134">
<rect width="31" height="30" fill="white"/>
</clipPath>
</defs>
</svg>



                          </a>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Container fluid className="footerWhite">
        <Row>
          <Col>
            <h4>
              Ⓒ Copyright © {new Date().getFullYear()} Montironi Ford - <br className="d-block d-md-none" /> Todos los
              derechos reservados
            </h4>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Footer;
